export const getRoleIdFromRoleText = (role) => {
    // Already a role id (GUID-like) from backend/UI flow.
    const roleIds = [
        process.env.REACT_APP_APP_ADMIN,
        process.env.REACT_APP_APP_TECHNICALUSER,
        process.env.REACT_APP_APP_TECHNICALBASIC,
        process.env.REACT_APP_APP_PREMIUMUSER,
        process.env.REACT_APP_APP_BASICUSER,
        process.env.REACT_APP_APP_VIEWER
    ]
    if (roleIds.includes(role)) return role

    switch (role) {
        case "App.Admin":
        case "Administrator":
        case "Admin":
            return process.env.REACT_APP_APP_ADMIN
        case "App.Technical":
        case "Technical":
            return process.env.REACT_APP_APP_TECHNICALUSER
        case "App.TechnicalBasic":
        case "TechnicalBasic":
        case "Technical Basic":
            return process.env.REACT_APP_APP_TECHNICALBASIC
        case "App.Premium":
        case "Premium":
            return process.env.REACT_APP_APP_PREMIUMUSER
        case "App.BasicUser":
        case "BasicUser":
        case "Basic User":
            return process.env.REACT_APP_APP_BASICUSER
        case "App.Viewer":
        case "Viewer":
            return process.env.REACT_APP_APP_VIEWER
        default:
            console.warn(`getRoleIdFromRoleText: no corresponding role id for role with text ${role}`)
            return ""
    }
}